import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'httpsPrefix'
})
export class HttpsPrefixPipe implements PipeTransform {
    transform(value: string): string {
        if (/^https?:\/\//i.test(value)) {
            return value;
        } else {
            return 'https://' + value;
        }
    }
}
